import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TopRibbon {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  TopRibbonData?: any;
}

const initialState: TopRibbon = {
  isLoading: false,
  error: false,
  message: null,
  TopRibbonData: [],
};

const TopRibbonSlice = createSlice({
  name: "TopRibbon",
  initialState,
  reducers: {
    loadingTopRibbon: (state: TopRibbon, action: PayloadAction) => {
      state.isLoading = true;
    },
    setTopRibbon: (state: any, action: PayloadAction<TopRibbon>) => {
      return action.payload;
    },
    clearData: (state: TopRibbon, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingTopRibbon, setTopRibbon, clearData } =
  TopRibbonSlice.actions;

export default TopRibbonSlice.reducer;
